var map = {
	"./testimonial-01.jpg": 7905,
	"./testimonial-02.jpg": 5766,
	"./testimonial-03.jpg": 531,
	"./testimonial-04.jpg": 368,
	"./testimonial-05.jpg": 2109,
	"./testimonial-06.jpg": 4306,
	"./testimonial-07.jpg": 687,
	"./testimonial-08.jpg": 2876,
	"./testimonial-09.jpg": 7017,
	"./testimonial-10.jpg": 2275,
	"./testimonial-11.jpg": 2166,
	"./testimonial-12.jpg": 8017,
	"./testimonial-13.jpg": 6212,
	"./testimonial-14.jpg": 847
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2544;